import * as React from 'react'
import { tw } from 'utils/classnames'
import { Slot } from 'primitives/slot'

type ButtonVariants = 'primary' | 'primary-green' | 'secondary' | 'normal'
export interface ButtonProps extends Omit<React.HTMLProps<HTMLButtonElement>, 'ref'> {
  asChild?: boolean
  className?: string
  type?: 'button' | 'submit' | 'reset'
  variant?: ButtonVariants
  ref?: React.Ref<HTMLButtonElement>
}

export const Button = ({
  ref,
  asChild,
  children,
  className,
  type,
  variant,
  disabled,
  ...rest
}: ButtonProps) => {
  const variants: Record<ButtonVariants, string> = {
    primary: 'text-service-white  bg-cf-violet hover:bg-cf-violet-hover',
    normal: 'bg-gray-800 text-cf-sf-gray-1000 font-medium hover:bg-cf-sf-gray-50',
    secondary: `border border-cf-violet text-cf-violet ${
      disabled ? '' : 'hover:shadow-cf-elevation-light-1'
    }`,
    'primary-green': 'text-service-white bg-secondary-500 hover:bg-secondary-700 font-bold',
  }

  const Comp = asChild ? Slot : 'button'

  return (
    <Comp
      ref={ref}
      className={tw(
        'text-14 rounded-2 mb-2 mt-2 flex h-[45px] items-center justify-center font-medium transition-[background-color]  disabled:cursor-not-allowed disabled:opacity-75',
        variants[variant || 'primary'],
        className,
      )}
      type={type || 'button'}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Comp>
  )
}

Button.displayName = 'Button'
